export default __webpack_public_path__ + "static/media/notfound.005dc773.jpg";